import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Button } from '@/common/ui/button'
import useMutationDeleteChannel from '@/modules/manage-player/api/hooks/useMutationDeleteChannel'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'
import { GetChannelTableData } from '@/modules/manage-player/type'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'

interface DeleteChannelDialogProps {
	data: GetChannelTableData
}

export const DeleteChannelDialog = ({ data }: DeleteChannelDialogProps) => {
	const queryClient = useQueryClient()
	const { mutate: deleteChannel } = useMutationDeleteChannel()

	const handleDelete = () => {
		deleteChannel(
			{ id: data.id },
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: [PlayerQueryKeys.GetChannelList],
					})
					toast.success('ลบช่องทางสำเร็จ')
				},
				onError: (error: any) => {
					if (error?.response?.data?.message === 'CHANNEL_HAS_PLAYERS') {
						showErrorToast(
							'ไม่สามารถลบช่องทางได้เนื่องจากยังมีผู้เล่นใช้งานอยู่',
						)
					} else {
						showErrorToast(error)
					}
				},
			},
		)
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบช่องทาง</AlertDialogTitle>
					<AlertDialogDescription>
						คุณแน่ใจหรือไม่ที่จะลบช่องทางนี้? การกระทำนี้ไม่สามารถย้อนกลับได้
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction onClick={handleDelete}>ยืนยัน</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
